import { Fragment, useState, useEffect, useRef } from "react";

import MergerInputs from "./MergerInputs";
import MergerSettings from "./MergerSettings";
import MergerResult from "./MergerResult";
// import CombinerResult from "./CombinerResult";


import { useStore } from "../../hook-store/store";
import './ImageMerger.css';


export default function ImageMerger(props) {

  const [store, dispatch] = useStore();
  // const { gLoading } = store.uiStore;

  // const [combinedB64String, setCombinedB64String] = useState("");
  // const [combinerInputFiles, setCombinerInputFiles] = useState([]);

  const [inputFiles, setInputFiles] = useState([]);
  const [fileDimensions, setFileDimensions] = useState([]);
  const [mergedFile, setMergedFile] = useState();

  useEffect(() => {
    window.scrollTo(0,0);
  },[]);

  let bannerElement;

  if (window.innerWidth <= 450) {
    bannerElement = (
      <iframe id="kura-image-photo.spaceeight.net-1697437603549"
        style={{width:"310px", height:"70px", border:"none"}}  
        src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-image-photo.spaceeight.net-1697437603549"
      />
    );
  }

  if (window.innerWidth > 450 && window.innerWidth <= 768) {
    bannerElement = (
      <iframe id="kura-image-photo.spaceeight.net-1697437618599"
        style={{width:"460px", height:"95px", border:"none"}}  
        src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-image-photo.spaceeight.net-1697437618599"
      />
    )
  }

  if (window.innerWidth > 768) {
    bannerElement = (
      <iframe id="kura-image-photo.spaceeight.net-1697437639506"
        style={{width:"610px", height:"135px", border:"none"}}  
        src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-image-photo.spaceeight.net-1697437639506"
      />
    );
  }

  return (
    <Fragment>
      <div className="imageCombiner">

        <div 
          style={{
            display: 'flex',
            justifyContent: "center",
            paddingBottom: "2rem"
          }}
        >
          {bannerElement}
        </div>

        <MergerInputs 
          inputFiles={inputFiles}
          setInputFiles={setInputFiles}
          fileDimensions={fileDimensions}
          setFileDimensions={setFileDimensions}
          // setCombinedB64String={setCombinedB64String} 
          // setCombinerInputFiles={setCombinerInputFiles}
        />

        <MergerSettings 
          inputFiles={inputFiles}
          fileDimensions={fileDimensions}
          mergedFile={mergedFile}
          setMergedFile={setMergedFile}
          // setInputFiles={setInputFiles}
          // setFileDimensions={setFileDimensions}
        />

        <MergerResult 
          inputFiles={inputFiles}
          mergedFile={mergedFile}
          setMergedFile={setMergedFile}
        />
      </div>
    </Fragment>
  );
}
